/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, EmojiFlagsOutlined, Google, MoneyOutlined} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import {ESTADOSMOVIMIENTO, TIPOSMOVIMIENTO, TIPOSRETIRO} from "../../Constantes";
import {useState} from "react";
import IngresoSelectFuncion from "../../Modulo_formularios/Componentes/IngresoSelectFuncion";

const Formulario_Retiro = ({...props}) => {


    const seleccionar = (sec) =>{

        if (sec === 'Aceptado'){
            calcularDetalle()
        }

    }

    const calcularDetalle = () =>{

        let valores =  props.props.getValues()
        console.log(valores)
        let metodo = {}

        let index = TIPOSRETIRO.findIndex((e) => e.nombre === valores.metodo);
        if (index > -1) {
            metodo = TIPOSRETIRO[index]
        }else{
            return
        }


        let valorSacar = valores.valor * -1
        let valorComision = valorSacar * metodo.porcentaje / 100
        let valorDesembolsado = valorSacar - valorComision

        let detalles = `Desembolsado ${valorDesembolsado.toFixed(2)} UDS, Tipo de retiro: ${metodo.nombre}`

        props.props.setValue('detalle', detalles)

    }


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Datos de Usuario</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre de Usuario'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'} editable={false}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Google} nombre={'Correo'} dato={'correo'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Direccion de billetera</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={2} nombre={''} dato={'billetera'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Datos del Retiro</Typography>
                </Grid>


                <Grid container size={6}>
                    <IngresoSelectFuncion Icono={EmojiFlagsOutlined} nombre={'Estado'} dato={'estado'} {...props}
                                   opciones={ESTADOSMOVIMIENTO} setDato={seleccionar}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={MoneyOutlined} nombre={'Valor del retiro'} dato={'valor'} {...props}
                                   editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={MoneyOutlined} nombre={'Metodo de retiro'} dato={'metodo'} {...props}
                                   editable={false}
                    />
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto lineas={3} nombre={'Notas para Usuario'} dato={'detalle'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Datos del Deposito</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={3} nombre={'Hash de la transaccion'} dato={'hashTransaccion'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Retiro